import { render, staticRenderFns } from "./member-relation.vue?vue&type=template&id=978db742&scoped=true&"
import script from "./member-relation.vue?vue&type=script&lang=js&"
export * from "./member-relation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978db742",
  null
  
)

export default component.exports